import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { AppState } from '../_reducers';
import { selectAllPayments } from '../_selectors/payment.selectors';

@Injectable()
export class PaymentService {
  private apiBaseUrl = environment.apiBaseUrl;
  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {}

  getClientToken(): Observable<any> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/store/braintree/getToken').pipe(
      map((response) => {
        if (response) {
          return response.token;
        }
        return null;
      })
    );
  }

  getPayments(): Observable<any> {
    return this.http.get(this.apiBaseUrl + 'api/private/v1/store/payments').pipe(
      map((response) => {
        if (response) {
          return response;
        }
        return null;
      })
    );
  }

  paymentSession(data): Observable<any> {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/store/braintree/nonceToServer', data)
      .pipe(
        map((response) => {
          if (response) {
            return true;
          }
          return null;
        })
      );
  }

  NewPaymentMethodSession(data): Observable<any> {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/transaction/create-payment-method', data)
      .pipe(
        map((response) => {
          if (response) {
            return response;
          }
          return null;
        })
      );
  }

  getMyTransaction(): Observable<any[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/store/braintree/userTransactions')
      .pipe(map((response) => response));
  }

  removeRecurringPayment(id): Observable<any[]> {
    return this.http
      .post<
        any[]
      >(this.apiBaseUrl + 'api/private/v1/store/braintree/cancelSubscription?payment_Id=' + id, null)
      .pipe(map((response) => response));
  }

  getMyRecurringPayment(): Observable<any> {
    return this.http
      .post(this.apiBaseUrl + 'api/private/v1/store/braintree/userSubscriptions', null)
      .pipe(
        map((response) => {
          if (response) {
            return response;
          }
          return null;
        })
      );
  }

  getEquipmentProviders(): Observable<string[]> {
    return this.store.select(selectAllPayments).pipe(
      map((response: any[]) => {
        if (!response) return [];

        const providers: string[] = [];
        response.forEach((metadataObj: any) => {
          if (metadataObj.metaData) {
            metadataObj.metaData.forEach((meta) => {
              if (meta.key === 'provider') {
                providers.push(meta.value);
              }
            });
          }
        });

        return providers;
      })
    );
  }
}
